// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zircuitTestnet as _zircuitTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zircuitTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 48899
 * Chain Name: Zircuit Testnet
 * Default Block Explorer: https://explorer.zircuit.com
 * Default RPC URL: https://zircuit1.p2pify.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zircuitTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zircuitTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zircuitTestnet = createCommon({
	..._zircuitTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
